export default "__VITE_ASSET__Cl0ZWxbS__"